import { createAsyncThunk } from "@reduxjs/toolkit";
import { showToast } from "../../toast/reducer";
import { getAdminProfile, updateAdminProfile } from "../../../helpers/apis";

export const editUser = createAsyncThunk(
  "profile/editUser",
  async (data, thunkAPI) => {
    try {
      const response = await updateAdminProfile(data);

      // Handle API response structure: { statusCode, status, message, data }
      if (response && response.status === 1) {
        const message = response.message || "Profile updated successfully";
        thunkAPI.dispatch(showToast({ type: "success", msg: message }));

        // Update localStorage with new admin data
        const authStr = localStorage.getItem("authUser");
        if (authStr && response.data) {
          const auth = JSON.parse(authStr);
          auth.user = response.data;
          localStorage.setItem("authUser", JSON.stringify(auth));
        }

        return response;
      } else {
        const errorMsg = response?.message || "Failed to update profile";
        thunkAPI.dispatch(showToast({ type: "error", msg: errorMsg }));
        return thunkAPI.rejectWithValue(errorMsg);
      }
    } catch (error) {
      const errorMsg = error?.message || error?.msg || "An error occurred while updating profile";
      thunkAPI.dispatch(showToast({ type: "error", msg: errorMsg }));
      return thunkAPI.rejectWithValue(errorMsg);
    }
  }
);

export const fetchProfile = createAsyncThunk(
  "profile/fetchProfile",
  async (_, thunkAPI) => {
    try {
      const response = await getAdminProfile();

      // Handle API response structure: { statusCode: 200, status: 1, message: "Profile fetched successfully", data: {...} }
      if (response && response.status === 1 && response.data) {
        // Update localStorage with admin data
        const authStr = localStorage.getItem("authUser");
        if (authStr) {
          const auth = JSON.parse(authStr);
          auth.user = response.data;
          localStorage.setItem("authUser", JSON.stringify(auth));
        }

        return response;
      } else {
        const errorMsg = response?.message || "Failed to fetch profile";
        thunkAPI.dispatch(showToast({ type: "error", msg: errorMsg }));
        return thunkAPI.rejectWithValue(errorMsg);
      }
    } catch (error) {
      const errorMsg = error?.message || error?.msg || "An error occurred while fetching profile";
      thunkAPI.dispatch(showToast({ type: "error", msg: errorMsg }));
      return thunkAPI.rejectWithValue(errorMsg);
    }
  }
);
